import { initI18n } from "@redotech/redo-i18n/i18n";
import { getStorefrontMoneyLocale } from "./storefront-locale";

function storefrontFormattingLocale(): string | undefined {
  try {
    return getStorefrontMoneyLocale() ?? globalThis.navigator?.language;
  } catch {
    return globalThis.navigator?.language;
  }
}

/**
 * Imported by every storefront entry point: shared components format with
 * `i18n.language`. English-only, since t() keys are the English copy.
 */
initI18n({ en: {}, loaders: {} }, { locale: storefrontFormattingLocale() });
